<template>
    <modal id="large-card-modal" size="xl" class="large-modal" scrollable :hide-footer="hideFooter">
        <template v-slot:modal-title>
            <b-container class="header-container">
                <b-row>
                    <div class="logo-container">
                        <img :src="icon" alt="Partner Logo" class="logo" />
                    </div>
                    <b-col>
                        <h1 class="modal-title-text">{{ title }}</h1>
                        <p class="modal-subtitle-text">{{ subtitle }}</p>
                        <p v-if="link"><a class="modal-link-text" :href="link" target="_blank"> {{ link }} </a></p>
                        <slot name="header-tooltips"></slot>
                    </b-col>
                </b-row>
            </b-container>
        </template>
        <b-row>
            <b-col cols="12" class="left-content-container">
                <slot name="left-content"></slot>
            </b-col>
        </b-row>
    </modal>
</template>


<script>
import Modal from '../../generic/modal/modal.vue';

export default {
    name: 'LargeModal',
    components: {
        Modal,
    },
    props: {
        title: {
            type: String,
        },
        subtitle: {
            type: String,
        },
        icon: {
            type: String,
        },
        link: {
            type: String,
        },
        hideFooter: {
            type: Boolean,
            default: true,
        },
    },
};
</script>

<style lang="scss" scoped>
    @import "~bootstrap/scss/_functions.scss";
    @import "~bootstrap/scss/_variables.scss";
    @import "~bootstrap/scss/mixins/_breakpoints.scss";

    @media (min-width: 1200px) {
        :deep(.modal-xl) {
            max-width: 1200px !important;
        }
    }

    @media (min-width: 992px) {
        :deep(.modal-xl) {
            max-width: 992px !important;
        }
    }

    @media (min-width: 567px) {
        :deep(.modal-xl) {
            max-width: 900px !important;
        }
    }

    :deep(.modal-header) {
        background-color: whitesmoke;
        padding: 2rem !important;
        flex-direction: row;
    }

    :deep(.modal-body) {
        padding: 0 !important;
        overflow-y: auto;
        overflow-x: hidden;
    }

    :deep(.modal-body img) {
        width: 100%;
        margin-top: 8px;
        margin-bottom: 8px;
    }

    :deep(.modal-body a) {
        text-decoration: underline;
        font-size: 14px;
        font-weight: 400px;
        color: #737376;
    }

    :deep(.modal-body video) {
        width: 100%;
        margin-top: 8px;
        margin-bottom: 8px;
    }

    .logo-container {
        width: 112px;
        height: 112px;
        border-radius: 4px;
        border: 1px solid #ebebeb;
        background-color: #fff;
    }

    .category-label {
        font-size: 14px;
        font-weight: 400;
        color: #737376;
        padding-top: 16px;
    }

    .logo-container .logo {
        width: 112px;
        height: 112px;
        padding: 0.5rem;
        vertical-align: middle;
    }

    .modal-subtitle-text {
        font-size: 14px;
        line-height: 20px;
        color: #222;
        padding: 0px;
        margin-left: 16px;
        margin-bottom: 0px;
        font-weight: 300;
    }

    .modal-link-text {
        font-size: 12px;
        line-height: 20px;
        color: #0b6c99;
        padding: 0px;
        margin-bottom: 8px;
        margin-left: 16px;
        font-weight: 300;
    }

    .modal-title-text {
        font-size: 22px;
        margin-bottom: 4px;
        margin-left: 16px;
        line-height: 27px;
        color: #222;
    }

    .left-content-container {
        padding: 2rem 3rem 2rem 3rem !important;
        font-size: 14px;
        line-height: 20px;
        color: #222;
        font-weight: 400;
        max-height: 750px;
    }

    @media (max-width: 567px) {

        .tooltips {
            display: inline-grid;
        }
    }
</style>